import React from "react";
import { useMemo } from "react";

const OrganizationTextDetails = ({ organizationDetailsData }) => {
  const mobileNo = useMemo(() => {
    return (
      organizationDetailsData?.resource.contact &&
      organizationDetailsData?.resource.contact[0]?.telecom.find(
        (item) => item.system === "phone"
      )
    );
  }, [organizationDetailsData.resource.contact]);

  return (
    <div className="info-container">
      <div>
        <span className="label">Hospital - </span>
        {organizationDetailsData.resource.name}
      </div>
      {organizationDetailsData.resource.contact && (
        <div>
          <span className="label">Address - </span>
          {organizationDetailsData.resource.contact[0].address.line[0]}
        </div>
      )}
      {mobileNo && (
        <div>
          <span className="label">Mobile No. - </span>
          {mobileNo.value}
        </div>
      )}
    </div>
  );
};

export default OrganizationTextDetails;
